import { MathHelper } from "projects/lib_util/src/lib/helpers/math.helper";

export class Settings {
    static SilentRenew = class {
        static TimeoutInSeconds = class {
            public static readonly minimumDelay = 10;
            public static readonly safetyTime = 30;
        }

        static ThresholdInSeconds = class {
            public static readonly threshold = 9 * 60;
            public static readonly thresholdVariance = 5 * 60;

            public static createThresholdWithVariance(): number {
                if( Settings.SilentRenew.ThresholdInSeconds.thresholdVariance >= Settings.SilentRenew.ThresholdInSeconds.threshold)
                    throw 'Variance is higher or equal to treshold';

                if((Settings.SilentRenew.ThresholdInSeconds.threshold - Settings.SilentRenew.ThresholdInSeconds.thresholdVariance) < 1)
                    throw 'Threshold minimum is less than 1 minute. This is not allowed for safety!';

                return Settings.SilentRenew.ThresholdInSeconds.threshold - MathHelper.getRandomInt(this.thresholdVariance);
            }
        }
    }
}